"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextContent = exports.StyledButton = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _Button = _interopRequireDefault(require("../../Button"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "exqwsp82"
} : {
  target: "exqwsp82",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;gap:0.5rem;justify-content:start;padding:1rem 0;border-bottom:", props.hideBorderBottom ? 'none' : '1px solid #d8e4f9', ";svg{margin-top:3px;min-width:14px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const TextContent = exports.TextContent = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "exqwsp81"
} : {
  target: "exqwsp81",
  label: "TextContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1vmat21",
  styles: "display:flex;flex-direction:column;text-align:left;&>span{line-height:1.5em;text-align:left;font-weight:normal;text-transform:none;&>span{font-weight:600;text-transform:none;}}"
} : {
  name: "1vmat21",
  styles: "display:flex;flex-direction:column;text-align:left;&>span{line-height:1.5em;text-align:left;font-weight:normal;text-transform:none;&>span{font-weight:600;text-transform:none;}}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const StyledButton = exports.StyledButton = /*#__PURE__*/(0, _base.default)(_Button.default, process.env.NODE_ENV === "production" ? {
  target: "exqwsp80"
} : {
  target: "exqwsp80",
  label: "StyledButton"
})(process.env.NODE_ENV === "production" ? {
  name: "13nmmot",
  styles: "width:100%;&>span{width:100%;}"
} : {
  name: "13nmmot",
  styles: "width:100%;&>span{width:100%;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});